import React, { Component } from 'react';
import styled from 'styled-components';
import { Row, StyledNavLink } from '../theme/index';
import AchieveLogo from '../../assets/logo.png';
import Hamburger from '../shared/Burger';
import Avatar from '../shared/Avatar';
import DropdownModal from '../shared/DropdownModal';
import { connect } from 'react-redux';
import { fetchProfile } from './redux/actions';
import { userData } from './redux/selector';
import { withRouter } from 'react-router-dom';
import LiveChat from 'react-livechat';

const Wrapper = styled.div`
  background: ${props => props.background || 'rgba(0, 0, 0, 0)'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  width: 100%;
  position: absolute;
  top: 0;
`;

const Logo = styled.img`
  width: 350px;
  height: 63px;
  margin-left: 3em;
  @media (max-width: 1100px) {
    width: 235px;
    height: 42px;
    margin-left: 1em;
  }
`;

const Div = styled.div`
  margin: 0;
  display: none;
  @media (max-width: 920px) {
    display: block;
  }
`;

const StyledRow = styled(Row)`
  align-items: center;
  @media (max-width: 920px) {
    display: none;
  }
`;

export const StyledCreateNavLink = styled(StyledNavLink)`
  background-color: #ffaf77;
  padding: 0.5em;
  border-radius: 3px;
`;

class Header extends Component {
  state = {
    firstName: '',
    lastName: '',
    state: '',
    profession: '',
  };

  componentDidMount() {
    if (this.isAuthenticated()) {
      this.props
        .fetchProfile()
        .then(action => {
          // let state = action.data.state.replace(/\s+/g, '-');
          // let profession = action.data.program.replace(/\s+/g, '-');
          let state = action.data.state
            .replace(/(^[A-Z])/, ([first]) => first.toLowerCase())
            .replace(/([A-Z])/g, ([letter]) => `-${letter.toLowerCase()}`);

          let profession = action.data.program
            .replace(/(^[A-Z])/, ([first]) => first.toLowerCase())
            .replace(/([A-Z])/g, ([letter]) => `-${letter.toLowerCase()}`);

          this.setState({
            firstName: action.data.firstname || '',
            lastName: action.data.lastname || '',
            state: state.trim() || '',
            profession: profession.trim() || '',
          });
        })
        .catch(error => {
          console.log(error);
        });
    } else {
      console.log('not authenticated');
    }
  }

  getInitials = () => {
    if (this.isAuthenticated()) {
      let name = `${this.state.firstName} ${this.state.lastName}`;
      let initials = name.match(/\b\w/g) || [];
      initials = (
        (initials.shift() || '') + (initials.pop() || '')
      ).toUpperCase();
      return initials;
    } else {
      console.log('not authenticated');
    }
  };

  onClickOption = () => {
    this.livechat.open_chat_window();
  };

  onClickExternal = val => {
    window.location.href = val.link;
  };

  logout = val => {
    this.props.history.push(val.link);
    localStorage.clear();
  };

  getOptions = () => {
    return [
      {
        label: 'My Courses',
        link: 'https://learn.achievece.com/enrollments',
        onClick: this.onClickExternal,
      },
      {
        label: 'My Certificates',
        link: 'https://learn.achievece.com/account/certificates',
        onClick: this.onClickExternal,
      },
      {
        label: 'My Account',
        link: 'https://learn.achievece.com/account',
        onClick: this.onClickExternal,
      },
      {
        label: 'Support',
        onClick: this.onClickOption,
      },
      {
        label: 'Sign Out',
        link: '/',
        onClick: this.logout,
      },
    ];
  };

  isAuthenticated = () => {
    return localStorage.getItem('authorization');
  };

  formatText = str => {
    let result = str.replace(/([A-Z])/g, '-$1');
    return result.charAt(0) + result.slice(1);
  };

  render() {
    const { type, style } = this.props;
    const { state, profession } = this.state;

    return (
      <Wrapper background={type === 'login' && '#2A425E'} style={style}>
        <LiveChat
          onChatLoaded={ref => (this.livechat = ref)}
          license={10146992}
        />
        <StyledNavLink
          exact
          to="/"
          activeStyle={{
            color: '#FFAF77',
          }}
        >
          <Logo src={AchieveLogo} alt="AchieveCE Logo" />
        </StyledNavLink>
        <Div>
          <React.Fragment>
            <Hamburger />
          </React.Fragment>
        </Div>

        <StyledRow>
          <StyledNavLink
            exact
            to="/"
            activeStyle={{
              color: '#FFAF77',
            }}
          >
            Home
          </StyledNavLink>
          <StyledNavLink
            exact
            to="/about"
            activeStyle={{
              color: '#FFAF77',
            }}
          >
            About
          </StyledNavLink>
          {this.isAuthenticated() ? (
            <StyledNavLink
              exact
              to={
                profession && state
                  ? `/${this.formatText(profession)}/${state}`
                  : '/findce'
              }
              activeStyle={{
                color: '#FFAF77',
              }}
            >
              Find more courses
            </StyledNavLink>
          ) : (
            <StyledNavLink
              exact
              to="/findce"
              activeStyle={{
                color: '#FFAF77',
              }}
            >
              Find your CE
            </StyledNavLink>
          )}
          {/* <StyledNavLink
            exact
            to="/resources"
            activeStyle={{
              color: '#FFAF77',
            }}
          >
            Resources
          </StyledNavLink>  */}
          <StyledNavLink
            exact
            to="/corporate"
            activeStyle={{
              color: '#FFAF77',
            }}
          >
            Corporate
          </StyledNavLink>
          {this.isAuthenticated() ? (
            <Avatar
              initials={this.getInitials() || null}
              background="#FFAF77"
              render={display => (
                <DropdownModal options={this.getOptions()} display={display} />
              )}
            />
          ) : (
            <React.Fragment>
              <StyledNavLink exact to="/login">
                Login
              </StyledNavLink>
              <StyledCreateNavLink exact to="/signup">
                Sign up
              </StyledCreateNavLink>
            </React.Fragment>
          )}
        </StyledRow>
      </Wrapper>
    );
  }
}

export default withRouter(
  connect(
    userData,
    { fetchProfile }
  )(Header)
);



// WEBPACK FOOTER //
// ./src/components/shared/Header.jsx